var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoilMoistureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.48,6.85A3,3,0,0,0,11.54,7a3.18,3.18,0,0,0,2.05-.75C15.67,4.51,16,.78,16,.62l0-.54-.54,0c-.2,0-5.11-.41-6.8,2.42a2.63,2.63,0,0,0-.31,1.79,3.55,3.55,0,0,0,1,2h0A10.62,10.62,0,0,0,9,7.33a6.2,6.2,0,0,0-1.61-1.5h0A2.32,2.32,0,0,0,7.48,5,2.64,2.64,0,0,0,5.13,2.53C3,2.33.7,4.15.6,4.23l-.42.34L.52,5A8.71,8.71,0,0,0,1.78,6.27,5.6,5.6,0,0,0,4.62,7.66l.29,0A2.58,2.58,0,0,0,6.67,7,2.67,2.67,0,0,0,7,6.62,5.35,5.35,0,0,1,8.63,8.78c0,.17-.07.34-.09.51H0v1.4H16V9.29H9.59a9,9,0,0,1,.57-2.57ZM4.9,6.58H4.74a5.69,5.69,0,0,1-3-1.82A5.62,5.62,0,0,1,5,3.63,1.51,1.51,0,0,1,6.38,5a1.37,1.37,0,0,1,0,.29h0c-.22-.09-.45-.18-.68-.25A10.2,10.2,0,0,0,4,4.72L3.9,5.3a8.85,8.85,0,0,1,1.55.42A4.85,4.85,0,0,1,6.06,6a1,1,0,0,1-.14.17A1.54,1.54,0,0,1,4.9,6.58ZM9.63,3c1-1.71,3.81-1.92,5.09-1.92h.1a11.54,11.54,0,0,1-.54,2.15,5.31,5.31,0,0,1-1.41,2.2,2,2,0,0,1-2,.37,1.08,1.08,0,0,1-.24-.12A9.51,9.51,0,0,1,13,2.77l-.37-.48A10,10,0,0,0,10,5.19h0a2.45,2.45,0,0,1-.51-1.13A1.5,1.5,0,0,1,9.63,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.22,11.86H7.93L6.37,14.45a2,2,0,0,0,0,2,1.93,1.93,0,0,0,1.7.91,1.88,1.88,0,0,0,1.67-.92,2,2,0,0,0,0-2Zm.44,4a.83.83,0,0,1-1.3,0,.82.82,0,0,1,0-.81l.64-1,.59,1A.83.83,0,0,1,8.66,15.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.84,14.86H2.47L1,17.37a2,2,0,0,0,0,2,1.94,1.94,0,0,0,1.7.91,1.88,1.88,0,0,0,1.67-.92,2,2,0,0,0,0-2Zm.4,3.92a.83.83,0,0,1-1.3,0A.82.82,0,0,1,2,18l.64-1.06.59,1A.85.85,0,0,1,3.24,18.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14,13.3h-.31l-1.56,2.56a2,2,0,0,0,0,2,1.93,1.93,0,0,0,1.69.91,1.87,1.87,0,0,0,1.68-.92,2,2,0,0,0,0-2Zm.43,4a.83.83,0,0,1-1.3,0,.84.84,0,0,1,0-.81l.65-1.05.59,1A.83.83,0,0,1,14.47,17.27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoilMoistureIcon);
export default __webpack_public_path__ + "static/media/soilMoistureIcon.3544c45318150f6c6f49dd44f42c75a5.svg";
export { ForwardRef as ReactComponent };